// extracted by mini-css-extract-plugin
var _1 = "peHlxeSjasoeo_x9DlQy";
var _2 = "Gcbl1Ap8spfeQr8oW8Ha";
var _3 = "izKyopy3AtlGSnuw9ydg";
var _4 = "vqcjSD_TLcDD5dZ4T7vc";
var _5 = "SxHh_PQl4FcijrXKU_6X";
export { _1 as "item", _2 as "noAccessReportsDescription", _3 as "report", _4 as "reports", _5 as "title" }
